/**
 * Product Bundles JS
 * Bundle selection and cart add integration (one-time purchase only).
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initProductBundles();
  });

  function initProductBundles() {
    var bundlesContainers = document.querySelectorAll('.product-bundles');

    bundlesContainers.forEach(function(container) {
      var bundleCards = container.querySelectorAll('.bundle-card');
      var bundleIndexInput = container.querySelector('#bundle-index');

      // Bundle card selection
      bundleCards.forEach(function(card) {
        card.addEventListener('click', function() {
          bundleCards.forEach(function(c) { c.classList.remove('bundle-card--selected'); });
          card.classList.add('bundle-card--selected');

          var index = card.dataset.bundleIndex;
          if (bundleIndexInput) bundleIndexInput.value = index;

          syncToProductForm(card);
          renderGifts(card);
        });
      });


      // Initialize sync for default selected bundle
      var initialSelected = container.querySelector('.bundle-card--selected');
      if (initialSelected) {
        syncToProductForm(initialSelected);
        renderGifts(initialSelected);
      }
    });
  }

  // Gifts unlock left-to-right: bundle index N unlocks every gift with tier <= N
  function renderGifts(card) {
    var wrap = document.querySelector('[data-gift-rewards]');
    if (!wrap || !card) return;
    var idx = parseInt(card.dataset.bundleIndex, 10) || 0;
    var gifts = wrap.querySelectorAll('[data-gift]');
    var nextLabel = null;
    gifts.forEach(function (g) {
      var tier = parseInt(g.dataset.tier, 10) || 0;
      var unlocked = idx >= tier;
      g.classList.toggle('is-unlocked', unlocked);
      if (!unlocked && nextLabel === null) {
        var lbl = g.querySelector('.gift__label');
        nextLabel = { text: lbl ? lbl.textContent.trim() : '', tier: tier };
      }
    });
    var hint = wrap.querySelector('[data-gift-hint]');
    if (hint) {
      if (nextLabel) {
        var cards = document.querySelectorAll('.bundle-card');
        var target = cards[nextLabel.tier];
        var name = target ? (target.querySelector('.bundle-card__title') || {}).textContent : '';
        hint.textContent = 'Elige ' + (name || '').trim() + ' y desbloquea ' + nextLabel.text;
      } else {
        hint.textContent = '¡Has desbloqueado todos los regalos!';
      }
    }
  }

  // Variant ids for the $0 gift line items that are currently unlocked
  function unlockedGiftVariantIds() {
    var wrap = document.querySelector('[data-gift-rewards]');
    if (!wrap) return [];
    var ids = [];
    wrap.querySelectorAll('[data-gift].is-unlocked').forEach(function (g) {
      var v = g.dataset.variantId;
      if (v && g.dataset.giftKind !== 'shipping') ids.push(parseInt(v, 10));
    });
    return ids;
  }

  function syncQty(card, form) {
  var q = parseInt(card && card.dataset ? card.dataset.qty : 1) || 1;
  var qi = form.querySelector('input[name="quantity"]');
  if (!qi) { qi = document.createElement('input'); qi.type = 'hidden'; qi.name = 'quantity'; form.appendChild(qi); }
  qi.value = q;
}

function syncToProductForm(card) {
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    syncQty(card, productForm);

    var variantId = card.dataset.variantId;

    // Update variant ID
    var idInput = productForm.querySelector('input[name="id"]');
    if (idInput && variantId) {
      idInput.value = variantId;
    }

    // One-time purchase only: never submit a selling_plan
    var sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput) sellingPlanInput.parentNode.removeChild(sellingPlanInput);
  }

  // Add the product together with whatever gifts the chosen bundle unlocked
  document.addEventListener('DOMContentLoaded', function () {
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    productForm.addEventListener('submit', function (e) {
      var gifts = unlockedGiftVariantIds();
      if (!gifts.length) return;

      e.preventDefault();
      productForm.dataset.drawerHandled = 'true';

      var mainVariantId = productForm.querySelector('input[name="id"]').value;
      var qtyInput = productForm.querySelector('input[name="quantity"]');
      var mainQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var items = [{ id: parseInt(mainVariantId, 10), quantity: mainQty }];
      gifts.forEach(function (id) { items.push({ id: id, quantity: 1 }); });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          delete productForm.dataset.drawerHandled;
          if (window.openCartDrawer) window.openCartDrawer();
          else if (window.Livianna && window.Livianna.CartDrawer) window.Livianna.CartDrawer.open();
        })
        .catch(function (err) {
          console.error('Cart add error:', err);
          delete productForm.dataset.drawerHandled;
        });
    });
  });

  // Expose for external access
  window.ProductBundles = {
    getSelected: function(containerId) {
      var container = document.getElementById(containerId);
      if (!container) return null;

      var selectedCard = container.querySelector('.bundle-card--selected');

      return {
        bundleIndex: selectedCard ? selectedCard.dataset.bundleIndex : 0,
        price: selectedCard ? parseFloat(selectedCard.dataset.price) : 0,
        variantId: selectedCard ? selectedCard.dataset.variantId : null
      };
    }
  };
})();

// Relocate the bundle section into the product buy box (before the ATC form)
function lvRelocateBundles() {
  var bundles = document.querySelector('.product-bundles');
  var form = document.querySelector('.product__info form[action*="/cart/add"], .product__info-container form[action*="/cart/add"], form[action*="/cart/add"]');
  if (!bundles || !form) return;
  var info = form.closest('.product__info, .product__info-container, .product__details');
  if (!info) return;
  var section = bundles.closest('.shopify-section') || bundles;
  section.style.margin = '0';
  bundles.style.maxWidth = 'none';
  bundles.style.padding = '0';
  form.parentNode.insertBefore(section, form);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lvRelocateBundles);
} else {
  lvRelocateBundles();
}
